import { createRequestTypes } from 'common/websocket-redux';

export const FETCH_GROUP_VENDORS = createRequestTypes(
  'benefits/FETCH_GROUP_VENDORS',
);

export const ADD_VENDOR_TO_PRODUCT_SYNC = createRequestTypes(
  'benefits/ADD_VENDOR_TO_PRODUCT_SYNC',
);
